<template>
  <div class="card-container" @click="gotoPath(path)">
    <div class="item-link">
      <div class="item-content">
        <div class="left-icon">
          <SvgIcon v-if="meta?.svgIcon" :name="meta?.svgIcon as string" />
        </div>
        <div class="right-content">
          <div class="title-content">
            <span class="title">{{ meta?.title }}</span>
            <span class="tag" :class="{ orange: meta?.tag == 'dev' }">{{ meta?.tag }}</span>
          </div>
          <div class="discribe">{{ meta?.description }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import type { RouteMeta } from '~/types/router';

interface Props {
  path: string;
  meta?: RouteMeta;
}

defineProps<Props>();

const router = useRouter();
const gotoPath = (path: string) => {
  navigateTo(path);
};
</script>

<style scoped lang="scss">
.card-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 120px;
  padding: 20px;
  border-radius: 6px;
  transition: all 0.3s;
  border: 1px solid rgba(0, 0, 0, 0.1);
  &:hover {
    transform: translateY(-6px);
    box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
    cursor: pointer;
  }
}
.item-link {
  width: 100%;
  display: block;
  box-sizing: border-box;
}

.item-content {
  display: flex;
  flex-direction: row;
  color: rgba(0, 0, 0, 1);
  .left-icon {
    width: 50px;
    display: grid;
    place-items: center;
    font-size: 30px;
  }

  .right-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    .title-content {
      .title {
        padding: 4px 6px;
        font-size: 15px;
      }

      .tag {
        background-color: rgb(232, 246, 251);
        color: rgba(2, 156, 212);
        border-radius: 3px;
        padding: 2px 10px;
        font-size: 13px;
      }

      .orange {
        background-color: rgb(255, 242, 204);
        color: rgba(255, 140, 0);
      }
    }

    .discribe {
      margin-top: 6px;
      padding: 1px 6px;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.5);
    }
  }
}
</style>
